const URL = 'https://contact.otiumsoft.com'
module.exports = {
    API_URL: `${URL}/contacts/new`,
};